<template>
  <div class="relative aspect-[1.333/1] overflow-hidden rounded-xl shadow-sm">
    <div class="relative size-full">
      <SpectreConsumerImage
        :src="property.media[0]?.thumbnailUrl ?? ''"
        :alt="address"
        object-fit="cover"
        aspect-ratio="4/3"
        class="size-full"
      />
      <div class="absolute inset-0 size-full bg-gradient-to-t from-black/80 to-transparent" />
    </div>
    <div class="px-base absolute bottom-0 w-full py-2.5">
      <PropertyCardTitle
        v-if="address"
        as="h5"
      >
        {{ address }}
      </PropertyCardTitle>
      <PropertyCardDescription v-if="property.salesListing">
        <template v-if="property.salesListing.priceQualifier">
          {{ property.salesListing.priceQualifier }} £{{ property.salesListing.priceFormatted }}
        </template>
        <template v-else>
          £{{ property.salesListing.priceFormatted }}
        </template>
      </PropertyCardDescription>
      <PropertyCardDescription v-else-if="property.lettingsListing">
        £{{ property.lettingsListing.pricePcmFormatted }} PCM
      </PropertyCardDescription>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { SpectreConsumerImage } from '@agentsoftware/spectre-consumer-ui';
import PropertyCardTitle from '@/Pages/LinkGroups/Partials/PropertyCard/PropertyCardTitle.vue';
import PropertyCardDescription from '@/Pages/LinkGroups/Partials/PropertyCard/PropertyCardDescription.vue';
import PropertyData = App.Data.Atlas.PropertyData;

const props = defineProps<{
  property: PropertyData;
}>();

const address = computed<string>(() => {
  const thoroughfare = props.property.address?.thoroughfare;

  if (!thoroughfare) {
    return props.property.publicAddress ?? '';
  }

  return [thoroughfare, props.property.address?.outcode].filter(Boolean).join(' ');
});
</script>
